import { Pipe, PipeTransform } from '@angular/core';
import { ErrorTypes } from '../models/mac-address';
import { MacAddressService } from '../services/mac-address.service';

@Pipe({
  name: 'errorMessage',
  standalone: true
})
export class ErrorMessagePipe implements PipeTransform {

constructor(private addressService: MacAddressService) {
  }

  transform(value: ErrorTypes): string {
    return this.addressService.prepareErrorMessage(value);
  }

}
